"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeCV = void 0;
const types_1 = require("../types");
const _1 = require(".");
const utils_1 = require("../utils");
const errors_1 = require("../errors");
function bufferWithTypeID(typeId, buffer) {
    const id = Buffer.from([typeId]);
    return Buffer.concat([id, buffer]);
}
function serializeBoolCV(value) {
    return Buffer.from([value.type]);
}
function serializeOptionalCV(cv) {
    if (cv.type === _1.ClarityType.OptionalNone) {
        return Buffer.from([cv.type]);
    }
    else {
        return bufferWithTypeID(cv.type, serializeCV(cv.value));
    }
}
function serializeBufferCV(cv) {
    const length = Buffer.alloc(4);
    length.writeUInt32BE(cv.buffer.length, 0);
    return bufferWithTypeID(cv.type, Buffer.concat([length, cv.buffer]));
}
function serializeIntCV(cv) {
    const buffer = cv.value.toArrayLike(Buffer, 'be', 16);
    return bufferWithTypeID(cv.type, buffer);
}
function serializeStandardPrincipalCV(cv) {
    return bufferWithTypeID(cv.type, types_1.serializeAddress(cv.address));
}
function serializeContractPrincipalCV(cv) {
    return bufferWithTypeID(cv.type, Buffer.concat([types_1.serializeAddress(cv.address), types_1.serializeLPString(cv.contractName)]));
}
function serializeResponseCV(cv) {
    return bufferWithTypeID(cv.type, serializeCV(cv.value));
}
function serializeListCV(cv) {
    const buffers = new utils_1.BufferArray();
    const length = Buffer.alloc(4);
    length.writeUInt32BE(cv.list.length, 0);
    buffers.push(length);
    for (const value of cv.list) {
        const serializedValue = serializeCV(value);
        buffers.push(serializedValue);
    }
    return bufferWithTypeID(cv.type, buffers.concatBuffer());
}
function serializeTupleCV(cv) {
    const buffers = new utils_1.BufferArray();
    const length = Buffer.alloc(4);
    length.writeUInt32BE(Object.keys(cv.data).length, 0);
    buffers.push(length);
    const lexicographicOrder = Object.keys(cv.data).sort((a, b) => {
        const bufA = Buffer.from(a);
        const bufB = Buffer.from(b);
        return bufA.compare(bufB);
    });
    for (const key of lexicographicOrder) {
        const nameWithLength = types_1.createLPString(key);
        buffers.push(types_1.serializeLPString(nameWithLength));
        const serializedValue = serializeCV(cv.data[key]);
        buffers.push(serializedValue);
    }
    return bufferWithTypeID(cv.type, buffers.concatBuffer());
}
function serializeStringCV(cv, encoding) {
    const buffers = new utils_1.BufferArray();
    const str = Buffer.from(cv.data, encoding);
    const len = Buffer.alloc(4);
    len.writeUInt32BE(str.length);
    buffers.push(len);
    buffers.push(str);
    return bufferWithTypeID(cv.type, buffers.concatBuffer());
}
function serializeStringAsciiCV(cv) {
    return serializeStringCV(cv, 'ascii');
}
function serializeStringUtf8CV(cv) {
    return serializeStringCV(cv, 'utf8');
}
function serializeCV(value) {
    switch (value.type) {
        case _1.ClarityType.BoolTrue:
        case _1.ClarityType.BoolFalse:
            return serializeBoolCV(value);
        case _1.ClarityType.OptionalNone:
        case _1.ClarityType.OptionalSome:
            return serializeOptionalCV(value);
        case _1.ClarityType.Buffer:
            return serializeBufferCV(value);
        case _1.ClarityType.Int:
        case _1.ClarityType.UInt:
            return serializeIntCV(value);
        case _1.ClarityType.PrincipalStandard:
            return serializeStandardPrincipalCV(value);
        case _1.ClarityType.PrincipalContract:
            return serializeContractPrincipalCV(value);
        case _1.ClarityType.ResponseOk:
        case _1.ClarityType.ResponseErr:
            return serializeResponseCV(value);
        case _1.ClarityType.List:
            return serializeListCV(value);
        case _1.ClarityType.Tuple:
            return serializeTupleCV(value);
        case _1.ClarityType.StringASCII:
            return serializeStringAsciiCV(value);
        case _1.ClarityType.StringUTF8:
            return serializeStringUtf8CV(value);
        default:
            throw new errors_1.SerializationError('Unable to serialize. Invalid Clarity Value.');
    }
}
exports.serializeCV = serializeCV;
//# sourceMappingURL=serialize.js.map